import React, { useState } from "react";
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import "./style.scss";

const basicOptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.6,
  plugins: {
    legend: {
      labels: {
        color: "#495057",
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#495057",
      },
      grid: {
        color: "#ebedef",
      },
    },
    y: {
      ticks: {
        color: "#495057",
      },
      grid: {
        color: "#ebedef",
      },
    },
  },
};

const lineStylesData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Third Dataset",
      data: [12, 51, 62, 33, 21, 62, 45],
      fill: true,
      borderColor: "#FFA726",
      tension: 0.4,
      backgroundColor: "rgba(255,167,38,0.2)",
    },
  ],
};

const Meter = (props) => {
  const {meter} = props;
  const [showDetails, setShowDetails] = useState(false);
  return (
    <div className="row meter-collapsed">
      <div className="item-info col-2">
        <p className="m-0 font-bold text-sm">Label</p>
        <p className="m-0">{meter.label}</p>
      </div>

      <div className="item-info col-2">
        <p className="m-0 font-bold">number</p>
        <p className="m-0">{meter.number}</p>
      </div>
      {/* <div className="item-info col-2">
        <p className="m-0 font-bold">Status</p>
        <Badge value="running" severity="success" className="mr-2"></Badge>
      </div> */}

      <div className="actions col-2 justify-content-end align-items-center d-flex offset-md-5">
        <Button 
         onClick={() => props.deleteMeter()}
          className="p-button-outlined p-button-rounded delete mx-2"
          icon="pi pi-trash"
        />
      </div>

      <div className="item-info col justify-content-end align-items-center d-flex">
        <p
          onClick={() => setShowDetails(!showDetails)}
          className="m-0 cursor-pointer"
        >
          <i className={showDetails ? "pi pi-angle-up" : "pi pi-angle-down"} />
        </p>
      </div>

      {showDetails && (
        <Chart type="line" data={lineStylesData} options={basicOptions} />
      )}
    </div>
  );
};

export default Meter;
